import { TaskDTO } from './taskDTO.model';

export class ShowreportDTO {
  performanceId?: number = 0;
  timePreshow?: string = '';
  timeShow?: string = '';
  timeEndShow?: string = '';
  stagemanagerId?: number = 0;
  showcallerId?: number = 0;
  troubleshooterId?: number = 0;
  floortechnicianId?: number = 0;
  toneelmeesterId?: number = 0;
  extraCrew: string = null;
  stagemanagerEarlyShift?: boolean = false;
  showcallerEarlyShift?: boolean = false;
  troubleshooterEarlyShift?: boolean = false;
  floortechnicianEarlyShift?: boolean = false;
  toneelmeesterEarlyShift?: boolean = false;
  extraCrewEarlyShift?: boolean = false;
  lightCheck?: boolean = false;
  lightCheckMessage?: string = '';
  followMeCheck?: boolean = false;
  followMeCheckMessage?: string = '';
  audioCheck?: boolean = false;
  audioCheckMessage?: string = '';
  flamesCheck?: boolean = false;
  flamesCheckMessage?: string = '';
  revolveCheck?: boolean = false;
  revolveCheckMessage?: string = '';
  hoistsCheck?: boolean = false;
  hoistsCheckMessage?: string = '';
  sparkularsCheck?: boolean = false;
  sparkularsCheckMessage?: string = '';
  waterscreenCheck?: boolean = false;
  waterscreenCheckMessage?: string = '';
  trapdoorsCheck?: boolean = false;
  trapdoorsCheckMessage?: string = '';
  particularities?: string = '';
  tasklist?: string = '';
  tasks?: TaskDTO[];
  taskIdsToRemove?: number[] = [];
  status?: string = 'PUBLISHED';
}
